import { object, number } from 'yup'
import useTranslateWithLanguage from '../../Hooks/useTranslateWithLanguage'

import { CustomName } from '../Helpers'

const AttributesOffNumberField = (language) => {
  const translate = useTranslateWithLanguage('formValidation', language)
  return object().shape({
    name: CustomName(translate),
    value: number().required(translate('offNumberRequired')).min(1, translate('offNumberMin')).max(65536, translate('timeMax'))
  })
}

export default AttributesOffNumberField
